export default __webpack_public_path__ + "static/media/krilnekapije2.287f25f6.png";